// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['sq_AL']  = {
  "name": "sq_AL",
  "day": {
    "abbrev": [
      "Die ",
      "Hën ",
      "Mar ",
      "Mër ",
      "Enj ",
      "Pre ",
      "Sht "
    ],
    "full": [
      "e diel ",
      "e hënë ",
      "e martë ",
      "e mërkurë ",
      "e enjte ",
      "e premte ",
      "e shtunë "
    ]
  },
  "month": {
    "abbrev": [
      "Jan",
      "Shk",
      "Mar",
      "Pri",
      "Maj",
      "Qer",
      "Kor",
      "Gsh",
      "Sht",
      "Tet",
      "Nën",
      "Dhj"
    ],
    "full": [
      "janar",
      "shkurt",
      "mars",
      "prill",
      "maj",
      "qershor",
      "korrik",
      "gusht",
      "shtator",
      "tetor",
      "nëntor",
      "dhjetor"
    ]
  },
  "meridiem": [
    "PD",
    "MD"
  ],
  "date": "%Y-%b-%d",
  "time24": "%I.%M.%S. %Z",
  "dateTime": "%Y-%b-%d %I.%M.%S.%p %Z",
  "time12": "%I.%M.%S.%p %Z",
  "full": "%a %b %e %H:%M:%S %Z %Y"
}

